import {
    BANKMASTERLIST_SUCCESS,
    BANKMASTERLIST_FAILED,
    RESET_BANKMASTERLIST,
    LOADING_BANKMASTERLIST,
    BANKMASTERLIST_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BANKMASTERLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BANKMASTERLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BANKMASTERLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case BANKMASTERLIST_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BANKMASTERLIST:
            return (state = initialState);
        default:
            return state;
    }
};
